import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { API } from "@/config";

/* Magic-link one-click sign-in landed on from booking-confirmation emails: /auth/magic?token=… */
export const MagicAuth = () => {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const done = useRef(false);
  const [state, setState] = useState({ status: "verifying", message: "" });
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = params.get("token");
    if (!token) {
      setState({ status: "error", message: "Missing magic-link token." });
      return;
    }
    (async () => {
      try {
        const { data } = await axios.get(`${API}/auth/magic`, { params: { token } });
        toast.success(`Welcome back, ${data.name || data.email}!`);
        const target = data.reservation_id
          ? `/account?res=${encodeURIComponent(data.reservation_id)}`
          : "/account";
        window.location.replace(target);
      } catch (e) {
        setState({
          status: "error",
          message: e.response?.data?.detail || "This link is invalid or expired.",
        });
      }
    })();
  }, [params]);
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="glass p-8 md:p-10 max-w-md w-full text-center" data-testid="magic-auth-page">
        <Sparkles className="w-8 h-8 mx-auto text-[#FFD166] mb-4" />
        {state.status === "verifying" ? (
          <>
            <h2 className="font-serif text-2xl text-[#F6F1E4]">Opening your booking…</h2>
            <p className="text-[#B9C8D5] text-sm mt-2">Signing you in with one-tap magic ✨</p>
          </>
        ) : (
          <>
            <h2 className="font-serif text-2xl text-[#F6F1E4]" data-testid="magic-auth-error-title">Link no longer works</h2>
            <p className="text-[#B9C8D5] text-sm mt-2" data-testid="magic-auth-error-message">{state.message}</p>
            <button
              onClick={() => nav("/login?role=customer", { replace: true })}
              className="btn-primary mt-6"
              data-testid="magic-auth-fallback-login"
            >
              Sign in normally
            </button>
          </>
        )}
      </div>
    </div>
  );
};
